import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/Shiprepairspage.css";

const ShipRepairsPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [galleryIndex, setGalleryIndex] = useState(0);

  const bannerSlides = [
    "/wp-content/uploads/2016/02/DSC_2877-1.jpg",
    "/wp-content/uploads/2016/07/ship-repairs.png",
    "/wp-content/uploads/2016/07/ship-repairs.jpg",
    "/wp-content/uploads/2017/12/MV-MAERSK-AVON.jpg",
    "/wp-content/uploads/2017/12/DERDGER-AMBIORIX.jpg",
    "/wp-content/uploads/2017/12/DREDGER-JUN-YANG-1.jpg",
    "/wp-content/uploads/2017/12/MT.-MORNING-IBIS.jpg",
  ];

  const galleryImages = [
    "/wp-content/uploads/2016/02/DSC_3199.jpg",
    "/wp-content/uploads/2016/02/DSC_3171.jpg",
    "/wp-content/uploads/2016/02/DSC_2898.jpg",
    "/wp-content/uploads/2016/02/DSC_2877.jpg",
    "/wp-content/uploads/2016/02/DSC_1497.jpg",
    "/wp-content/uploads/2016/02/DSC_1042.jpg",
    "/wp-content/uploads/2016/02/DSC_0722.jpg",
  ];

  useEffect(() => {
    const t = setInterval(
      () => setCurrentSlide((p) => (p + 1) % bannerSlides.length),
      3000,
    );
    return () => clearInterval(t);
  }, [bannerSlides.length]);

  useEffect(() => {
    const t = setInterval(
      () => setGalleryIndex((p) => (p + 1) % galleryImages.length),
      3000,
    );
    return () => clearInterval(t);
  }, [galleryImages.length]);

  return (
    <>
      <Header />

      {/* Banner unchanged – no animation */}
      <section id="main-banner" className="sr-banner">
        {bannerSlides.map((src, i) => (
          <img
            key={i}
            src={src}
            alt="Ship Repairs"
            className={`sr-banner-img${i === currentSlide ? " active" : ""}`}
          />
        ))}
        <button
          className="sr-arrow sr-arrow--left"
          onClick={() =>
            setCurrentSlide(
              (p) => (p - 1 + bannerSlides.length) % bannerSlides.length,
            )
          }
          aria-label="Previous slide"
        >
          &#8249;
        </button>
        <button
          className="sr-arrow sr-arrow--right"
          onClick={() => setCurrentSlide((p) => (p + 1) % bannerSlides.length)}
          aria-label="Next slide"
        >
          &#8250;
        </button>
        <div className="sr-dots">
          {bannerSlides.map((_, i) => (
            <span
              key={i}
              className={`sr-dot${i === currentSlide ? " selected" : ""}`}
              onClick={() => setCurrentSlide(i)}
            />
          ))}
        </div>
      </section>

      <section className="contentwrapper clearfix">
        <div className="content clearfix">
          {/* Breadcrumb – no animation */}
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Ship Repairs</span>
          </div>

          <h1 data-aos="fade-right">Ship Repairs</h1>

          {/* Two columns */}
          <div className="sr-two-cols">
            <div className="sr-col-half" data-aos="fade-right">
              <p>
                In the ship repair sector, on average, Colombo Dockyard handles
                over 200 vessels annually with 100 accommodated in drydock and
                the balance accommodated at the alongside repair berth. Colombo
                Dockyard is capable of handling all routine, damage, and
                retrofit repairs.
              </p>
              <p>
                Colombo Dockyard operates four graving drydocks with a maximum
                capacity of up to 125,000 DWT and over 1000 meters of fully
                serviced alongside repair berths.
              </p>
              <p>
                The four drydocks range from 9000 to 125,000 DWT. The largest
                drydock caters to tankers, bulk carriers, and offshore drill
                rigs.
              </p>
              <p>
                The 30,000 DWT drydock accommodates the feeders and trampers
                plying regional waters.
              </p>
              <p>
                The two 9000 DWT drydocks provide ideal docking facilities for
                offshore support vessels, naval vessels, trawlers and work
                boats.
              </p>
            </div>

            <div className="sr-col-half" data-aos="fade-left">
              <p>
                Our workshops are fully equipped with the latest machinery and
                equipment and the yard is geared to cater to all types of ship
                repairs including,
              </p>
              <ul>
                <li data-aos="fade-right" data-aos-delay="100">
                  Machinery repairs
                </li>
                <li data-aos="fade-right" data-aos-delay="150">
                  Hull repairs
                </li>
                <li data-aos="fade-right" data-aos-delay="200">
                  Propeller repairs
                </li>
                <li data-aos="fade-right" data-aos-delay="250">
                  Electrical repairs
                </li>
                <li data-aos="fade-right" data-aos-delay="300">
                  Electronic and automation repairs
                </li>
                <li data-aos="fade-right" data-aos-delay="350">
                  Cargo gear repairs
                </li>
                <li data-aos="fade-right" data-aos-delay="400">
                  Internal tank, cargo hold blasting and coating
                </li>
                <li data-aos="fade-right" data-aos-delay="450">
                  Installation of ballast water treatment systems
                </li>
              </ul>
            </div>
          </div>

          {/* Gallery – no animation (interactive slider) */}
          <div className="sr-gallery-row">
            <div className="sr-gallery-spacer" />
            <div className="sr-gallery-col">
              <div className="sr-flexslider">
                {galleryImages.map((src, i) => (
                  <div
                    key={i}
                    className={`sr-flex-slide${i === galleryIndex ? " active" : ""}`}
                  >
                    <a
                      href={src}
                      data-fancybox="sr-gallery"
                      className="prettyphoto"
                    >
                      <img src={src} alt={`Ship Repair ${i + 1}`} />
                    </a>
                  </div>
                ))}
              </div>
            </div>
            <div className="sr-gallery-spacer" />
          </div>

          {/* ── Drydock repairs (full-width) ── */}
          <div
            className="sr-repairs-section repairs-undertaken clearfix"
            data-aos="fade-up"
          >
            <p>
              <strong>Drydock repairs undertaken include ;</strong>
            </p>
            <ul>
              <li data-aos="fade-right" data-aos-delay="100">
                High pressure water jetting and cleaning
              </li>
              <li data-aos="fade-right" data-aos-delay="150">
                Grit / shot blasting
              </li>
              <li data-aos="fade-right" data-aos-delay="200">
                Airless spray painting
              </li>
              <li data-aos="fade-right" data-aos-delay="250">
                Overhauling / installation of undersea fitting
              </li>
              <li data-aos="fade-right" data-aos-delay="300">
                Withdrawal of tail-end shafts
              </li>
              <li data-aos="fade-right" data-aos-delay="350">
                Renewal of stern bushes
              </li>
              <li data-aos="fade-right" data-aos-delay="400">
                Overhauling and renewal of stern seals
              </li>
              <li data-aos="fade-right" data-aos-delay="450">
                Unshipping of rudders
              </li>
              <li data-aos="fade-right" data-aos-delay="500">
                Checking and correcting alignment of rudders
              </li>
              <li data-aos="fade-right" data-aos-delay="550">
                Replacement of anodes
              </li>
              <li data-aos="fade-right" data-aos-delay="600">
                Installation and repair of cathodic protection systems
              </li>
              <li data-aos="fade-right" data-aos-delay="650">
                Non-destructive methods for testing radiography
              </li>
              <li data-aos="fade-right" data-aos-delay="700">
                Lignum vitae re-bushing
              </li>
              <li data-aos="fade-right" data-aos-delay="750">
                Ultrasonic x-rays and magnetic particle surveys
              </li>
              <li data-aos="fade-right" data-aos-delay="800">
                Load line inspections
              </li>
              <li data-aos="fade-right" data-aos-delay="850">
                Safety equipment surveys
              </li>
              <li data-aos="fade-right" data-aos-delay="900">
                Certifications
              </li>
            </ul>
          </div>

          {/* Quick links */}
          <div className="sr-quick-links">
            <h2 className="sr-link-item" data-aos="fade-right">
              <a href="/shipyard-layout.html">Dockyard layout</a>
            </h2>
            <h2 className="sr-link-item" data-aos="fade-left">
              <a href="/drydocks.html">Drydocks details</a>
            </h2>
          </div>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default ShipRepairsPage;
